module.exports = __webpack_public_path__ + "img/password-self.8c53ac53.png";